import React from 'react'
import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import { useReadOnly } from '../../../contexts/ReadOnlyContext'

export default observer(function CampaignInfluencerCommentsPanel({
  auth,
  isClientThread = false,
  onSubmitComment,
  CommentComponent,
  helperText = 'Only PMs can see this thread',
}) {
  const readOnly = useReadOnly()
  const comments = isClientThread ? auth.client_comments : auth.comments

  return (
    <div className='flex flex-col w-full h-full'>
      <div className="overflow-y-scroll flex-1 p-2 pb-32 w-full" style={{ minHeight: 800, maxHeight: 800 }}>
        {comments.map(comment => <CommentComponent key={comment.id} comment={comment} isClientThread={isClientThread} />)}
      </div>

      {!readOnly && <div className="sticky bottom-0 flex p-2 px-7 gap-3 bg-gray-100 dark:bg-rb-dark-mode-background w-full border-t border-gray-200 dark:border-rb-dark-mode-lighter">
        <div className="h-12 w-12 rounded-full bg-rb-green" />
        <div className='flex-grow'>
          <Formik
            initialValues={{ message: '' }}
            onSubmit={onSubmitComment}
          >
            {({ handleBlur, handleChange, values }) => (
              <Form className='flex flex-col justify-center'>
                <div className="flex flex-col border-2 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-lg bg-white dark:bg-rb-dark-mode p-2">
                  <textarea
                    name='message'
                    rows="2"
                    className='border-none rounded-lg w-full bg-transparent text-rb-black dark:text-rb-dark-mode-text-light placeholder-rb-mat-grey dark:placeholder-rb-dark-mode-text-grey focus:ring-transparent'
                    placeholder='Add your comment...'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.message}
                    style={{ resize: 'none' }}
                  />
                  <div className='flex gap-2 items-center justify-end mt-1'>
                    <p className='rb-text-secondary text-sm'>{helperText}</p>
                    <button
                      type="submit"
                      className="submit text-white bg-rb-green rounded-md py-1 px-3 text-center active:shadow-outer active:shadow-rb-green"
                    >
                      Comment
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>}
    </div>
  )
})
